import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  activeSubCard: {
    borderRadius: 20,
    padding: "12px 10px 20px 10px",
    backgroundColor: "#FFF",
    border: "2px solid #E5E5E5",
  },
  cardHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    padding: "3px 10px 15px 10px",
    borderBottom: "1px solid #D4D4D4",
    margin: 0,
  },
  infoWrapper: {
    flexDirection: "column",
    gap: 10,
    marginBlock: 20,
    paddingInline: 10,
  },
  label: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 700,
    color: "#000",
  },
  labelValueWrapper: {
    gap: 5,
    alignItems: "center",
  },
  value: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 400,
    color: "#000",
  },
  noAccountText: {
    fontFamily: "Inter",
    fontSize: 20,
    fontWeight: 400,
    color: "#000",
  },
  btnWrapper: {
    borderTop: "1px solid #E5E5E5",
    paddingTop: 20,
    display: "flex",
    alignItems: "center",
    gap: 12,
    paddingInline: 10,
  },
  addBtn: {
    width: "100%",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 600,
    backgroundColor: "#FFAF4A",
    border: "1px solid #FFAF4A",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 60,
    color: "#171717",
    "&:hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  updateBtn: {
    width: "100%",
    fontFamily: "Inter",
    fontSize: 18,
    fontWeight: 600,
    backgroundColor: "#F5F5F5",
    border: "1px solid #F5F5F5",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 60,
    color: "#262626",
    "&:hover": {
      backgroundColor: "#F5F5F5",
      opacity: 0.8,
    },
  },
  btn: {
    width: 200,
    fontFamily: "Inter",
    fontSize: 16,
    fontWeight: 600,
    backgroundColor: "#FFAF4A",
    border: "1px solid #FFAF4A",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    height: 44,
    color: "#171717",
    "&:hover": {
      backgroundColor: "#FFAF4A",
      opacity: 0.8,
    },
  },
  cardItem: {
    border: "1px solid #E5E5E5",
    borderRadius: 12,
    padding: "12px 16px",
    marginBottom: 8,
  },
  cardItemContent: {
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
  },
  switchWrapper: {
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    minWidth: 70,
  },
  switchLabel: {
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: 500,
    color: "#737373",
  },
  switch: {
    ".mantine-Switch-track": {
      width: 51,
      height: 31,
      borderRadius: 100,
      background: "rgba(120, 120, 128, 0.16)",
      border: "none",
    },
    ".mantine-Switch-thumb": {
      width: 27,
      height: 27,
      borderRadius: 100,
      background: "#FFF",
      boxShadow:
        "0 0 0 1px rgba(0, 0, 0, 0.04), 0 3px 8px 0 rgba(0, 0, 0, 0.15), 0 3px 1px 0 rgba(0, 0, 0, 0.06)",
    },
    "input:checked + .mantine-Switch-track": {
      background: "#34C759",
    },
    "input:checked + .mantine-Switch-track .mantine-Switch-thumb": {
      left: 2,
      transform: "translateX(20px)",
    },
  },
}));

export default useStyles;
